import React from 'react'
import * as Icon from "@ant-design/icons";

const IconFun = (props={})=>{
    const {icon='',style={},className=''} = props
    const antIcon = Icon
    return React.createElement(antIcon[icon]||antIcon['ConsoleSqlOutlined'],{style:{...style},className:className})
}
export default IconFun